import type { Theme } from '@mui/material';

export const styles = {
  iconWrapper: (theme: Theme) => ({
    px: 1,
    svg: {
      fontSize: '5rem',
      color: theme.colors.secondary[500],
    },
  }),
};
